// import React, {
//   forwardRef,
//   useImperativeHandle,
//   useRef,
//   useState,
// } from "react";
// import {
//   Button,
//   Col,
//   Form,
//   Modal,
//   Row,
// } from "react-bootstrap";
// import { useForm, Controller } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import { WebService } from "../../Services/WebService";
// import { WSSuccessAlert } from "../../Services/WSAlert";
// import { StandardConst } from "../../Services/StandardConst";

// const AddEditBroadcastDocument = forwardRef((props, ref) => {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     control,
//     setValue,
//     reset,
//     watch,
//   } = useForm();

//   const [show, setShow] = useState(false);
//   const [BroadcastDocumentId, setBroadcastDocumentId] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);
//   const [uploadedDocument, setUploadedDocument] = useState(null);
//   const [uploadedSignature, setUploadedSignature] = useState(null);
//   const fileInputRef = useRef();
//   const signatureInputRef = useRef();
//   const dispatch = useDispatch();
//   const dst = useSelector((s) => s.auth ?? {});
//   const UserInfo = useSelector((s) => s.auth.BasicInfo ?? {});
//   const CompanyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});

//   useImperativeHandle(ref, () => ({
//     openModal: async (id = 0) => {
//       reset();
//       setBroadcastDocumentId(id);
//       setUploadedDocument(null);
//       setUploadedSignature(null);
      
//       if (id > 0) {
//         await fetchBroadcastDocumentDetails(id);
//       } else {
//         // Set default values for new document
//         setValue("RequireAcknowledgment", false);
//         setValue("RequireSignature", false);
//         setValue("Label", "");
//       }
      
//       setShow(true);
//     },
//   }));

//   const fetchBroadcastDocumentDetails = async (id) => {
//     setIsLoading(true);
//     try {
//       const result = await WebService({
//         endPoint: `Document/GetBroadcastDocument/${id}`,
//         method: "GET",
//         dispatch,
//       });

//       if (result?.result) {
//         const data = result.result;
//         setValue("Title", data.Title);
//         setValue("RequireAcknowledgment", data.RequireAcknowledgment);
//         setValue("RequireSignature", data.RequireSignature || false);
//         setValue("Label", data.Label || "");
        
//         if (data.DocumentPath) {
//           setUploadedDocument({
//             name: data.DocumentPath.split('/').pop(),
//             path: data.DocumentPath
//           });
//         }
        
//         if (data.SignaturePath) {
//           setUploadedSignature({
//             name: data.SignaturePath.split('/').pop(),
//             path: data.SignaturePath
//           });
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching document:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };
// console.log(dst,'oooooooo');
//   const handleClose = () => {
//     setShow(false);
//     reset();
//     setBroadcastDocumentId(0);
//     setUploadedDocument(null);
//     setUploadedSignature(null);
//   };

// //  const onSubmit = async (data) => {
// //   setIsLoading(true);

// //   try {
// //     const formData = new FormData();

// //     formData.append("BroadcastDocumentId", BroadcastDocumentId);
// //     formData.append("Title", data.Title);
// //     formData.append(
// //       "RequireAcknowledgment",
// //       data.RequireAcknowledgment ? "1" : "0"
// //     );
// //     formData.append(
// //       "RequireSignature",
// //       data.RequireSignature ? "1" : "0"
// //     );
// //     formData.append("Label", data.Label || "");
// //     formData.append("CompanyId", CompanyInfo.CompanyId);
// //     formData.append("CreatedBy", UserInfo.UserId);

// //     if (fileInputRef.current?.files[0]) {
// //       formData.append("Document", fileInputRef.current.files[0]);
// //     }

// //     if (signatureInputRef.current?.files[0]) {
// //       formData.append("Signature", signatureInputRef.current.files[0]);
// //     }

// //     const result = await WebService({
// //       endPoint: "Document/CreateBroadcastDocument",
// //       method: "POST",
// //       body: formData,
// //       isFormData: true, // 👈 important
// //       dispatch,
// //     });

// //     if (result?.isSuccess) {
// //       WSSuccessAlert("", "Broadcast Document Created Successfully");
// //       handleClose();
// //       props.callBackEvent?.();
// //     }
// //   } catch (err) {
// //     console.error(err);
// //   } finally {
// //     setIsLoading(false);
// //   }
// // };




// const uploadFile = async (file) => {
//   const result = await WebService({
//     endPoint: "upload/File",
//     body: file,
//     dispatch,
//     isFile: true, // 👈 same flag
//   });

//   return result.filename; // backend se jo aa raha hai
// };
// const onSubmit = async (data) => {
//   setIsLoading(true);

//   try {
//     let documentFileName = uploadedDocument?.path ?? null;
//     let signatureFileName = uploadedSignature?.path ?? null;

//     // 🔹 upload document first
//     if (fileInputRef.current?.files[0]) {
//       documentFileName = await uploadFile(fileInputRef.current.files[0]);
//     }

//     // 🔹 upload signature if exists
//     if (signatureInputRef.current?.files[0]) {
//       signatureFileName = await uploadFile(signatureInputRef.current.files[0]);
//     }

//     // 🔹 now send JSON body
//     const payload = {
//       BroadcastDocumentId,
//       Title: data.Title,
//       RequireAcknowledgment: data.RequireAcknowledgment ? 1 : 0,
//       RequireSignature: data.RequireSignature ? 1 : 0,
//       Label: data.Label || "",
//       CompanyId: CompanyInfo.CompanyId,
//       CreatedBy: UserInfo.EmployeeId?? 0,
//       DocumentPath: documentFileName,
//       SignaturePath: signatureFileName,
//     };

//     const result = await WebService({
//       endPoint:
//         BroadcastDocumentId > 0
//           ? "Document/UpdateBroadcastDocument"
//           : "Document/CreateBroadcastDocument",
//       method: BroadcastDocumentId > 0 ? "PUT" : "POST",
//       body: payload, // ✅ JSON
//       dispatch,
//     });

//     if (result?.isSuccess) {
//       WSSuccessAlert(
//         "",
//         BroadcastDocumentId > 0
//           ? "Broadcast Document Updated Successfully"
//           : "Broadcast Document Created Successfully"
//       );
//       handleClose();
//       props.callBackEvent?.();
//     }
//   } catch (err) {
//     console.error(err);
//   } finally {
//     setIsLoading(false);
//   }
// };

//   const handleDocumentUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Validate file type (PDF, DOC, DOCX)
//       const validTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
//       if (!validTypes.includes(file.type)) {
//         alert('Please upload a PDF or Word document');
//         e.target.value = '';
//         return;
//       }
      
//       // Validate file size (max 10MB)
//       if (file.size > 10 * 1024 * 1024) {
//         alert('File size should be less than 10MB');
//         e.target.value = '';
//         return;
//       }
      
//       setUploadedDocument({ name: file.name });
//     }
//   };

//   const handleSignatureUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Validate file type (images only)
//       const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
//       if (!validTypes.includes(file.type)) {
//         alert('Please upload an image file (JPG, JPEG, PNG)');
//         e.target.value = '';
//         return;
//       }
      
//       // Validate file size (max 2MB)
//       if (file.size > 2 * 1024 * 1024) {
//         alert('Image size should be less than 2MB');
//         e.target.value = '';
//         return;
//       }
      
//       setUploadedSignature({ name: file.name });
//     }
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       backdrop="static"
//       keyboard={false}
//       size="lg"
//       centered
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>
//           {BroadcastDocumentId > 0 ? "Edit" : "Add"} Policy Document
//         </Modal.Title>
//       </Modal.Header>

//       <Form onSubmit={handleSubmit(onSubmit)}>
//         <Modal.Body>
//           {isLoading ? (
//             <div className="text-center py-5">
//               <div className="spinner-border text-primary" role="status">
//                 <span className="visually-hidden">Loading...</span>
//               </div>
//             </div>
//           ) : (
//             <Row>
//               {/* Title Field */}
//               <Col md={12} className="mb-3">
//                 <Form.Group>
//                   <Form.Label>
//                     Document Title <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Enter document title"
//                     {...register("Title", {
//                       required: "Title is required",
//                       maxLength: {
//                         value: 200,
//                         message: "Title cannot exceed 200 characters"
//                       }
//                     })}
//                     isInvalid={!!errors.Title}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.Title?.message}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>

//               {/* Document Upload */}
//               <Col md={12} className="mb-3">
//                 <Form.Group>
//                   <Form.Label>
//                     Upload Document <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="file"
//                     ref={fileInputRef}
//                     accept=".pdf,.doc,.docx"
//                     onChange={handleDocumentUpload}
//                     required={BroadcastDocumentId === 0 && !uploadedDocument}
//                   />
//                   <Form.Text className="text-muted">
//                     Supported formats: PDF, DOC, DOCX (Max 10MB)
//                   </Form.Text>
//                   {uploadedDocument && (
//                     <div className="mt-2">
//                       <small className="text-success">
//                         📄 {uploadedDocument.name}
//                         {uploadedDocument.path && (
//                           <a
//                             href={`${StandardConst.apiBaseUrl}/uploads/${uploadedDocument.path}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="ms-2"
//                           >
//                             View Current
//                           </a>
//                         )}
//                       </small>
//                     </div>
//                   )}
//                 </Form.Group>
//               </Col>

//               {/* Checkbox - Require Acknowledgment */}
         

//               {/* Checkbox - Require Signature */}
//               <Col md={12} className="mb-3">
//                 <Form.Group>
//                   <Form.Check
//                     type="checkbox"
//                     id="RequireSignature"
//                     label="Require Digital Signature from Employees"
//                     {...register("RequireSignature")}
//                   />
//                   <Form.Text className="text-muted">
//                     If checked, employees must digitally sign this document before submission
//                   </Form.Text>
//                 </Form.Group>
//               </Col>

//               {/* Label/Description Field */}
//               <Col md={12} className="mb-3">
//                 <Form.Group>
//                   <Form.Label>Label/Description (Optional)</Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     placeholder="Enter additional description or instructions"
//                     {...register("Label", {
//                       maxLength: {
//                         value: 500,
//                         message: "Label cannot exceed 500 characters"
//                       }
//                     })}
//                     isInvalid={!!errors.Label}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.Label?.message}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>

             
//               {/* Info Alert */}
//               <Col md={12}>
//                 <div className="alert alert-info" role="alert">
//                   <strong>ℹ️ Auto-Broadcast:</strong> This document will be automatically sent to all employees in your company. No manual selection required!
//                 </div>
//               </Col>
//             </Row>
//           )}
//         </Modal.Body>

//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={handleClose}
//             disabled={isLoading}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             type="submit"
//             disabled={isLoading}
//           >
//             {isLoading ? (
//               <>
//                 <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                 Saving...
//               </>
//             ) : (
//               BroadcastDocumentId > 0 ? "Update & Send to All" : "Create & Send to All"
//             )}
//           </Button>
//         </Modal.Footer>
//       </Form>
//     </Modal>
//   );
// });

// AddEditBroadcastDocument.displayName = "AddEditBroadcastDocument";

// export default AddEditBroadcastDocument;





import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { WebService } from "../../Services/WebService";
import { WSSuccessAlert } from "../../Services/WSAlert";
import { StandardConst } from "../../Services/StandardConst";

const AddEditBroadcastDocument = forwardRef((props, ref) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();

  const [show, setShow] = useState(false);
  const [BroadcastDocumentId, setBroadcastDocumentId] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  
  const [companyEmployeeList, setCompanyEmployeeList] = useState([]);
  const [uploadedDocument, setUploadedDocument] = useState(null);
  const fileInputRef = useRef();
  const dispatch = useDispatch();
  const UserInfo = useSelector((s) => s.auth.BasicInfo ?? {});
  const CompanyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});


  const fetchCompanyEmployeeList = async () => {
    var employeeList = await WebService({
      endPoint: `CommonUtility/employees`,
      dispatch,
    });
    employeeList = employeeList.filter((v) => 
      v.FullName && 
      v.DesignationId && 
      v.DesignationId !== 0
    );
     const employeeIds = employeeList.map(v => v.EmployeeId);
    setCompanyEmployeeList(employeeIds);
    return employeeIds;
 
  };

  useImperativeHandle(ref, () => ({
    openModal: async (id = 0) => {
      reset();
      setBroadcastDocumentId(id);
      setUploadedDocument(null);
      
      if (id > 0) {
        await fetchBroadcastDocumentDetails(id);
      } else {
        setValue("RequireSignature", false);
        setValue("Label", "");
      }
      
      setShow(true);
    },
  }));

  const fetchBroadcastDocumentDetails = async (id) => {
    setIsLoading(true);
    try {
      const result = await WebService({
        endPoint: `Document/GetBroadcastDocument/${id}`,
        method: "GET",
        dispatch,
      });

      if (result && result.result) {
        const data = result.result;
        setValue("Title", data.Title);
        setValue("RequireSignature", data.RequireSignature || false);
        setValue("Label", data.Label || "");
        
        if (data.DocumentPath) {
          setUploadedDocument({
            name: data.DocumentPath.split('/').pop(),
            path: data.DocumentPath
          });
        }
      }
    } catch (error) {
      console.error("Error fetching document:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
    reset();
    setBroadcastDocumentId(0);
    setUploadedDocument(null);
  };

  const uploadFile = async (file) => {
    const result = await WebService({
      endPoint: "upload/File",
      body: file,
      dispatch,
      isFile: true,
    });

    return result.filename;
  };

  const onSubmit = async (data) => {
    setIsLoading(true);

    try {
      let documentFileName = uploadedDocument && uploadedDocument.path ? uploadedDocument.path : null;

      if (fileInputRef.current && fileInputRef.current.files[0]) {
        documentFileName = await uploadFile(fileInputRef.current.files[0]);
      }

      const payload = {
        BroadcastDocumentId,
        Title: data.Title,
        RequireSignature: data.RequireSignature ? 1 : 0,
        Label: data.Label || "",
        CompanyId: CompanyInfo.CompanyId,
        CreatedBy: UserInfo.EmployeeId || 0,
        DocumentPath: documentFileName,
      };

      const result = await WebService({
        endPoint:
          BroadcastDocumentId > 0
            ? "Document/UpdateBroadcastDocument"
            : "Document/CreateBroadcastDocument",
        method: BroadcastDocumentId > 0 ? "PUT" : "POST",
        body: payload,
        dispatch,
      });

      if (result && result.isSuccess) {
        const employeeList = await fetchCompanyEmployeeList();
        //  console.log(employeeList, 'ABHI---',result); 
      // // 🔹 Notification bhejo sabhi employees ko
      await WebService({
        dispatch,
        endPoint: "Notification/Create",
        body: {
          Message: `New Policy Document has been shared. Please review and acknowledge.`,
          SendTo: employeeList, // Empty array = sabhi approved employees ko bhejega
          Expire: null, // Ya fir addDays(new Date(), 7) kar sakte ho
        },
      });

//  console.log(companyEmployeeList,'ABHI---');

        WSSuccessAlert(
          "",
          BroadcastDocumentId > 0
            ? "Broadcast Document Updated Successfully"
            : "Broadcast Document Created Successfully"
        );
        handleClose();
        if (props.callBackEvent) {
          props.callBackEvent();
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDocumentUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!validTypes.includes(file.type)) {
        alert('Please upload a PDF or Word document');
        e.target.value = '';
        return;
      }
      
      if (file.size > 10 * 1024 * 1024) {
        alert('File size should be less than 10MB');
        e.target.value = '';
        return;
      }
      
      setUploadedDocument({ name: file.name });
    }
  };

  return (
     <>
      <style>
        {`
          .custom-checkbox-label label {
            margin-left: 2.5px;
          }
        `}
      </style>
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {BroadcastDocumentId > 0 ? "Edit" : "Add"} Policy Document
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="p-4">
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {/* Title Field - Label Left, Field Right */}
              <Row className="mb-3 align-items-center">
                <Col md={4}>
                  <Form.Label className="mb-0">
                    Document Title <span className="text-danger">*</span>
                  </Form.Label>
                </Col>
                <Col md={8}>
                  <Form.Control
                    type="text"
                    placeholder="Enter document title"
                    {...register("Title", {
                      required: "Title is required",
                      maxLength: {
                        value: 200,
                        message: "Title cannot exceed 200 characters"
                      }
                    })}
                    isInvalid={!!errors.Title}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.Title && errors.Title.message}
                  </Form.Control.Feedback>
                </Col>
              </Row>

              {/* Document Upload - Label Left, Field Right */}
              <Row className="mb-3 align-items-start">
                <Col md={4}>
                  <Form.Label className="mb-0">
                    Upload Document <span className="text-danger">*</span>
                  </Form.Label>
                </Col>
                <Col md={8}>
                  <Form.Control
                    type="file"
                    ref={fileInputRef}
                    accept=".pdf,.doc,.docx"
                    onChange={handleDocumentUpload}
                    required={BroadcastDocumentId === 0 && !uploadedDocument}
                  />
                  <Form.Text className="text-muted d-block mt-1">
                    Supported formats: PDF, DOC, DOCX (Max 10MB)
                  </Form.Text>
                  {uploadedDocument && (
                    <div className="mt-2">
                      <small className="text-success">
                        📄 {uploadedDocument.name}
                        {uploadedDocument.path && (
                          
                          <a  href={`${StandardConst.apiBaseUrl}/uploads/${uploadedDocument.path}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ms-2"
                          >
                            View Current
                          </a>
                        )}
                      </small>
                    </div>
                  )}
                </Col>
              </Row>

              {/* Label/Description Field - Label Left, Field Right */}
              <Row className="mb-3 align-items-start">
                <Col md={4}>
                  <Form.Label className="mb-0">Label/Description (Optional)</Form.Label>
                </Col>
                <Col md={8}>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter additional description or instructions"
                    {...register("Label", {
                      maxLength: {
                        value: 500,
                        message: "Label cannot exceed 500 characters"
                      }
                    })}
                    isInvalid={!!errors.Label}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.Label && errors.Label.message}
                  </Form.Control.Feedback>
                </Col>
              </Row>


              {/* Checkbox - Require Signature - Full Width */}
              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id="RequireSignature"
                      label="Require Digital Signature from Employees"
                      {...register("RequireSignature")}
                       className="custom-checkbox-label"
                    />
                    <Form.Text className="text-muted d-block ms-4">
                      If checked, employees must digitally sign this document before submission
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              
              {/* Info Alert - Full Width */}
              <Row>
                <Col md={12}>
                  <div className="alert alert-info" role="alert">
                    <strong>ℹ️ Auto-Broadcast:</strong> This document will be automatically sent to all employees in your company. No manual selection required!
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Saving...
              </>
            ) : (
              BroadcastDocumentId > 0 ? "Update & Send to All" : "Create & Send to All"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
    </>
  );
});

AddEditBroadcastDocument.displayName = "AddEditBroadcastDocument";

export default AddEditBroadcastDocument;